import React from 'react';
import { useUiStateMatches, sendUiEvent, useUiCtxSelector } from '@/core';
import { Panel, TobyPanel } from '@knapsack/toby';
import { SuspenseAndErrorCatcher } from '@/utils/error-catcher';

export interface RightPanelProps {
  ariaLabel: string;
  title?: React.ReactNode;
  subTitle?: string;
  body?: React.ReactNode;
  footer?: React.ReactNode;
  onToggle?: () => void;
  testId?: string;
  actionBarLeft?: TobyPanel['actionBarLeft'];
  actionBarRight?: TobyPanel['actionBarRight'];
  top?: string;
}

const RightPanel = () => {
  const isPanelOpen = useUiStateMatches('rightPanel.opened');
  const rightPanel = useUiCtxSelector((ui) => ui.rightPanel);

  const handleToggle = () => {
    sendUiEvent('rightPanel.triggerClose');
    rightPanel?.onToggle?.();
  };

  return (
    <Panel
      ariaLabel={rightPanel?.ariaLabel || 'Right Panel'}
      id="right-panel"
      placement="right"
      opened={isPanelOpen}
      title={rightPanel?.title && rightPanel.title}
      subtitle={rightPanel?.subTitle && rightPanel.subTitle}
      onToggle={handleToggle}
      footer={rightPanel?.footer && rightPanel.footer}
      testId={rightPanel?.testId}
      theme={{
        position: 'absolute',
        top: rightPanel?.top,
      }}
      actionBarLeft={rightPanel?.actionBarLeft}
      actionBarRight={rightPanel?.actionBarRight}
    >
      <SuspenseAndErrorCatcher>{rightPanel?.body}</SuspenseAndErrorCatcher>
    </Panel>
  );
};

export default RightPanel;
